import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./read-time.m.css";

const showReadTimeBase = ({ storyReadTime, enableReadTime, customCssClasses }) => {
  return enableReadTime === "enable" && storyReadTime ? (
    <div styleName={`read-time-wrapper ${customCssClasses}`}>
      <div styleName="hidden-container">
        <span styleName="dot-content">.</span>
      </div>
      <span>{`${storyReadTime} ${storyReadTime > 1 ? "mins read" : "min read"}`}</span>
    </div>
  ) : null;
};

showReadTimeBase.propTypes = {
  storyReadTime: PropTypes.number,
  enableReadTime: PropTypes.string,
  customCssClasses: PropTypes.string
};

const mapStateToProps = state => ({
  enableReadTime: get(state, ["qt", "config", "theme-attributes", "read-time"], "disable")
});

export const ShowReadTime = connect(mapStateToProps)(showReadTimeBase);
